module.exports = __webpack_public_path__ + "img/img_decarbonisation_penurie.70d1fc1e.png";